import { VALIDATION_MESSAGE_DUPLICATE_USER, VALIDATION_MESSAGE_REQUIRED } from '../constants'
import moment from 'moment';
export const validateUserForm = (userDetails, allUserDetails) => {
    let flag = false, validationMessage;
    if (userDetails.firstName && userDetails.lastName && userDetails.contactNo && userDetails.email) {
        flag = duplicateUserValidation(userDetails, allUserDetails)
        if (flag === false) {
            validationMessage = VALIDATION_MESSAGE_DUPLICATE_USER;
            return { ValidationFlag: false, message: validationMessage }
        } else {
            return { validationFlag: true }
        }
    } else {
        validationMessage = VALIDATION_MESSAGE_REQUIRED;
        return { ValidationFlag: false, message: validationMessage }
    }
}

const duplicateUserValidation = (userDetails, allUsers) => {
    for (let i = 0; i < allUsers.length; i++) {
        if (allUsers[i].email === userDetails.email) {
            if (allUsers[i].enabled) {
                return false
            } else {
                return true
            }
        }
    }
}

export const createUser = (userAllData, userData, correspondentId) => {
    let tempId;
    if (userData.id) {
        tempId = userData.id;
    } else {
        tempId = 'js_' + userData.email + '_' + moment().unix();
    }
    userAllData.push({
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        contactNo: userData.contactNo,
        enabled: true,
        id: tempId
    })
    return userAllData;
}

export const updateUserData = (userData, userAllData) => {
    for (let i = 0; i < userAllData.length; i++) {
        if (userAllData[i].email === userData.email) {
            userAllData.splice(i, 1)
            break
        }
    }
    return userAllData
}

export const deleteUserData = (deleteUserData, allUserData) => {
    for (let i = 0; i < allUserData.length; i++) {
        if (allUserData[i].email === deleteUserData.email) {
            if (deleteUserData.id.substring(0, 2) === 'js') {
                allUserData.splice(i, 1);
                break;
            } else {
                allUserData[i].enabled = false;
                break;
            }

        }
    }
    return allUserData;
}

export const enableUser = (allUserData, id) => {
    for (let i = 0; i < allUserData.length; i++) {
        if (allUserData[i].id === id) {
            allUserData[i].enabled = true;
            break
        }
    }
    return allUserData
}